const addresses = {
  token: "0x599C7d9E32CFe8F5d4fc843C0e545382B6D670E5",
  legislatoor: "0xA40bbe853c3A5b194D51EAC7E088D13bb55614Ac",
};
export default addresses;
